<!--
 * @Description: description
 * @Author: chenguobiao
 * @Date: 2021-09-23 20:05:37
 * @LastEditTime: 2021-12-28 15:24:16
 * @LastEditors: chenguobiao
-->
<template>
  <div class="forget-page page-normal">
    <common-header selected="user" />
     <div class="forget-page__content page-normal__content">
      <div class="page-normal__content__box">
        <div class="title">
          <div class="left-main"><span class="line-bar"></span>注册信息</div>
          <div class="right-back" @click="handleBack">返回登录</div>
        </div>
        <div class="steps">
          <div class="step" :class="{finish: currentStep >= index}" v-for="(step, index) in steps" :key="index+step">
            <div class="step__head">
              <div class="step__line"></div>
              <div class="step__icon">
                <div class="step__icon-inner">{{index + 1}}</div>
              </div>
            </div>
            <div class="step__main">
              <div class="step__title">{{step}}</div>
            </div>
          </div>
        </div>
        <div class="step__content__box">
          <template v-if="currentStep === 0">
            <div class="first-step">
              <el-form :model="firstStepFormData" label-position="top">
                <el-form-item label="账号">
                  <el-input v-model.trim="firstStepFormData.loginName" placeholder="请输入账号" autocomplete="off"/>
                </el-form-item>
              </el-form>
              <div class="option__button" @click="handleClickNext">
                <img src="@/render/assets/images/auth/next-step.png">
              </div>
            </div>
          </template>
          <template v-else-if="currentStep === 1">
            <div class="second-step">
              <div class="verification-way" @click="handleChooseWay(0)">
                <div class="icon-image">
                  <img src="@/render/assets/images/auth/sms-verification.png">
                </div>
                <div class="way-text">手机短信验证</div>
              </div>
              <div class="verification-way" @click="handleChooseWay(1)">
                <div class="icon-image">
                  <img src="@/render/assets/images/auth/account-verification.png">
                </div>
                <div class="way-text">账号信息验证</div>
              </div>
            </div>
          </template>
          <template v-else-if="currentStep === 2">
            <div class="third-step" :class="{account: verificationWay === 1}">
              <!-- 短信验证 -->
              <template v-if="verificationWay === 0">
                <el-form ref="smsVerificationFormRef" :model="smsVerificationFormData" :rules="smsVerificationFules" label-position="top">
                  <el-form-item label="家长手机号" prop="parentPhone" class="mobile">
                    <el-input v-model="smsVerificationFormData.parentPhone" placeholder="请输入手机号" autocomplete="off"/>
                    <div class="send-message" @click="handleClickSendMessage">{{countDownTimes === 0 ? '获取验证码' : countDownTimes + 's'}}</div>
                  </el-form-item>
                  <el-form-item label="短信验证码" prop="code">
                    <el-input v-model="smsVerificationFormData.code" />
                  </el-form-item>
                </el-form>
              </template>
              <!-- 身份验证 -->
              <template v-else>
                <el-form :model="accountVerificationFormData" label-position="top">
                  <el-form-item label="真实姓名" prop="name">
                    <el-input v-model.trim="accountVerificationFormData.name" placeholder="请输入真实姓名" />
                  </el-form-item>
                  <el-form-item label="身份证号" prop="card">
                    <el-input v-model.trim="accountVerificationFormData.card" placeholder="请输入身份证号" autocomplete="off" />
                  </el-form-item>
                  <el-form-item label="预留家长姓名" prop="parentName">
                    <el-input v-model="accountVerificationFormData.parentName" placeholder="请输入预留家长姓名"/>
                  </el-form-item>
                </el-form>
              </template>
              <div class="option__button" @click="handleClickNext">
                <img src="@/render/assets/images/auth/next-step.png">
              </div>
            </div>
          </template>
          <template v-else-if="currentStep === 3">
            <div class="fourth-step" key='fourth-step'>
              <el-form ref="passwordFormRef" :model="passwordFormData" :rules="passwordFules" label-position="top">
                <el-form-item label="新密码" prop="password" class="password">
                  <el-input type="password" v-model.trim="passwordFormData.password" placeholder="请输入新密码" />
                  <span class="security-level" ref="tip" style="display:none;color:#666;"><span ref="level"></span></span>
                </el-form-item>
                <el-form-item label="再次输入新密码" prop="confirmPassword">
                  <el-input type="password" v-model.trim="passwordFormData.confirmPassword" placeholder="请再次输入新密码" autocomplete="off" />
                </el-form-item>
              </el-form>
              <div class="option__button" @click="handleClickNext">
                <img src="@/render/assets/images/auth/next-step.png">
              </div>
            </div>
          </template>
          <template v-else-if="currentStep === 4">
            <div class="five-step">
              <div class="update-success-image">
                <img src="@/render/assets/images/auth/register-success.png">
              </div>
              <div class="update-success-desc">设置完成  <span>{{loginCountDownTimes}}s</span> 后自动跳转登录</div>
              <div class="option__button" @click="handleClickNext">
                <img src="@/render/assets/images/auth/finish-step.png">
              </div>
            </div>
          </template>
        </div>
      </div>
     </div>
  </div>
</template>

<script>
import _ from 'lodash'
import CryptoJS from 'crypto-js'
import { authAPI } from '@/apis'
import CommonHeader from '@/render/components/common/header'
import { Timer } from '@/render/utils'
import { COUNTDOWN, LOGINCOUNTDOWN } from '@/config/const'
export default {
  name: 'ForgetPage',
  components: {
    CommonHeader
  },
  data() {
    const validate = {
      'PASSOWRD_REG_WEEK': /^[0-9]{6,8}$|^[A-Z]{6,8}$|^[a-z]{6,8}$|^[\W_!@#$%^&*`~()-+=]{6,8}$/,
      // eslint-disable-next-line no-control-regex
      'PASSOWRD_REG_MIDDLE': /^(?!\d+$)(?![a-zA-Z]+$)[\da-zA-Z]{8,10}$|^(?!\d+$)(?![\x00-\xff]+$)[\d\x00-\xff]{8,10}$|^(?!a-zA-Z+$)(?![\x00-\xff]+$)[a-zA-Z\x00-\xff]{8,10}$/,
      'PASSOWRD_REG_POWER': /^(?=.*[a-zA-Z])(?=.*[\W_!@#$%^&*`~()-+=])(?=.*\d)[^]{10,16}$|^(?=.*[a-zA-Z])(?=.*[\W_!@#$%^&*`~()-+=])[^]{10,16}$|^(?=.*\d)(?=.*[\W_!@#$%^&*`~()-+=])[^]{10,16}$|^(?=.*[a-zA-Z])(?=.*\d)[^]{10,16}$/
    }
    const validatePassword = (rule, value, callback) => {
      if (value.length < 6 || value.length > 16) {
        this.$refs.tip.style.display = 'none'
        callback(new Error('密码位数为6位 ~ 16位'))
      } else if (value === '') {
        callback(new Error('请输入新密码'))
      } else if (validate.PASSOWRD_REG_WEEK.test(value)) {
        this.$refs.level.innerText = '弱，建议加强'
        this.$refs.tip.style.display = 'block'
        callback()
      } else if (validate.PASSOWRD_REG_MIDDLE.test(value)) {
        this.$refs.level.innerText = '中'
        this.$refs.tip.style.display = 'block'
        callback()
      } else if (validate.PASSOWRD_REG_POWER.test(value)) {
        this.$refs.level.innerText = '强'
        this.$refs.tip.style.display = 'block'
        callback()
      }
    }
    const validatePasswordConsistent = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.passwordFormData.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    const validateMobile = (rule, value, callback) => {
      if (!value) {
        return new Error('请输入电话号码')
      } else {
        const reg = /^1[3|4|5|7|8][0-9]\d{8}$/
        const isPhone = reg.test(value)
        value = Number(value) // 转换为数字
        if (typeof value === 'number' && !isNaN(value)) { // 判断是否为数字
          value = value.toString() // 转换成字符串
          if (value.length < 0 || value.length > 12 || !isPhone) { // 判断是否为11位手机号
            callback(new Error('手机号码格式如:138xxxx8754'))
          } else {
            callback()
          }
        } else {
          callback(new Error('请输入电话号码'))
        }
      }
    }
    return {
      steps: ['检测账号', '选择方式', '验证身份', '设置新密码', '设置完成'],
      currentStep: 0,
      firstStepFormData: {
        loginName: ''
      },
      smsVerificationFormData: {
        parentPhone: '',
        code: ''
      },
      smsVerificationFules: {
        parentPhone: [
          { required: true, message: '请输入家长手机号', trigger: 'blur' },
          { validator: validateMobile, trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ]
      },
      accountVerificationFormData: {
        name: '',
        card: '',
        parentName: ''
      },
      passwordFormData: {
        password: '',
        confirmPassword: ''
      },
      passwordFules: {
        password: [
          { validator: validatePassword }
        ],
        confirmPassword: [
          { validator: validatePasswordConsistent, trigger: 'blur' }
        ]
      },
      verificationWay: 0,
      countDownTimes: 0,
      uid: '',
      loginCountDownTimes: 0
    }
  },
  methods: {
    handleBack() {
      this.$router.replace('/login')
    },
    handleClickNext: _.throttle(function() {
      switch (this.currentStep) {
        case 0:
          this.checkAccount()
          break;
        case 2:
          this.authenticate()
          break;
        case 3:
          this.setPassword()
          break;
        case 4:
          this.$router.replace('/login')
          break;
      }
    }, 500),
    handleClickSendMessage() {
      if (this.countDownTimes !== 0) return false
      this.$refs.smsVerificationFormRef.validateField('parentPhone', async errorMessage => {
        if (errorMessage === '') {
          try {
            await authAPI.postSendSmsCode({phone: this.smsVerificationFormData.parentPhone, loginName: this.firstStepFormData.loginName, type: 2})
            this.countDownTimes = 60
            let timer = new Timer(this.countDownTimes)
            timer.start(this.$bus, COUNTDOWN)
            this.$bus.on(COUNTDOWN, countDownTimes => {
              this.countDownTimes = countDownTimes
            })
          } catch (error) {
            throw error
          }
        }
      })
      
    },
    async checkAccount() {
      try {
        await authAPI.postCheckAccount(this.firstStepFormData)
        this.currentStep++
      } catch (error) {

      }
    },
    async authenticate() {
      // 短信验证
      if (this.verificationWay === 0) {
        this.$refs.smsVerificationFormRef.validate(async (valid, object) => {
          if (valid) {
            const {parentPhone: phone, code } = this.smsVerificationFormData
            const result = await authAPI.postCheckSmsCode({phone, code, loginName: this.firstStepFormData.loginName, type: 2})
            this.uid = result.data.uid
            this.currentStep++
          }
        })
      } else {
        // 身份验证
        try {
          const { data } = await authAPI.postCheckCard(this.accountVerificationFormData)
          this.uid = data.uid
          this.currentStep++
        } catch (error) {
          throw error
        }
      }
    },
    setPassword() {
      this.$refs.passwordFormRef.validate(async valid => {
        if (valid) {
          const submitFormData = {
            uid: this.uid,
            pwd: CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(this.passwordFormData.password))
          }
          try {
            await authAPI.postUpdatePwd(submitFormData)
            this.currentStep++
            this.handleLoginCountDown()
          } catch (error) {
            throw error
          }
        }
      })
    },
    handleLoginCountDown() {
      this.loginCountDownTimes = 10
      let timer = new Timer(this.loginCountDownTimes)
      timer.start(this.$bus, LOGINCOUNTDOWN)
      this.$bus.on(LOGINCOUNTDOWN, countDownTimes => {
        if (countDownTimes === 0) {
          this.$router.replace('/login')
          return
        }
        this.loginCountDownTimes = countDownTimes
      })
    },
    handleChooseWay(verificationWay) {
      this.verificationWay = verificationWay
      this.currentStep++
    }
  }
}
</script>

<style lang="scss" scoped>
  .forget-page {
    .page-normal__content__box {
      position: relative;
      padding: val(66) val(106) 0;
      background: url('../../../assets/images/auth/forget-bg.png') #fff no-repeat left top;
      background-size: 100%;
      .steps {
        display: flex;
        .step {
          flex: 1;
          &:last-of-type .step__line {
            display: none;
          }
          &__head {
            position: relative;
            display: flex;
            justify-content: center;
            .step__line {
              position: absolute;
              height: 2px;
              top: 50%;
              left: 50%;
              right: -50%;
              transform: translateY(-50%);
              background-color: #999;
            }
            .step__icon {
              display: flex;
              justify-content: center;
              align-items: center;
              position: relative;
              width: val(28);
              height: val(28);
              border: 2px solid #999;
              background-color: #fff;
              border-radius: 50%;
              box-sizing: border-box;
              z-index: 2;
              &-inner {
                font-size: val(16);
                font-weight: bold;
                color: #999;
              }
            }
          }
          &__main {
            padding-top: 10px;
            .step__title {
              text-align: center;
              font-size: val(16);
              color: #999;
            }
          }
          &.finish {
            .step__icon {
              border-color: #4E2500;
              &-inner {
                color: #4E2500;
              }
            }
            .step__main {
              .step__title {
                color: #4E2500;
              }
            }
          }
        }
      }
      .step__content__box {
        display: flex;
        justify-content: center;
        .first-step, .second-step, .third-step, .fourth-step {
          padding-top: val(100);
        }
        .second-step {
          display: flex;
          justify-content: center;
          .verification-way {
            display: flex;
            flex-direction: column;
            align-items: center;
            &:first-of-type {
              margin-right: val(100);
            }
            .icon-image {
              cursor: pointer;
              width: val(100);
              margin-bottom: val(16);
            }
            .way-text {
              font-size: val(16);
              color: #4E2500;
            }
          }
        }
        .third-step.account {
          padding-top: val(70);
        }
        .five-step {
          padding-top: val(65);
          .update-success-image {
            width: val(373);
            margin-bottom: val(30);
          }
          .update-success-desc {
            font-size: val(16);
            color: #5E3C00;
            text-align: center;
            span {
              color: #FF9900;
            }
          }
        }
      }
      .option__button {
        cursor: pointer;
        position: absolute;
        width: val(350);
        left: val(575);
        bottom: val(140);
      }
    }
  }
</style>
<style lang="scss">
  .forget-page {
    .el-form-item {
      width: val(244);
      margin: 0 0 30px;
      &:last-of-type {
        margin: 0;
      }
      .el-form-item__content {
        line-height: unset;
      }
      .el-input {
        .el-input__inner {
          background-color: #fff;
          border: none;
          padding: 0;
          height: val(37);
          line-height: val(37);
          font-size: val(16);
          color: #111;
        }
      }
      .el-form-item__label {
        float: left;
        font-size: val(16);
        color: #5E3C00;
        line-height: 1em;
        vertical-align: unset;
        padding-bottom: val(12);
      }
      .el-form-item__content {
        border-bottom: 1px solid rgba(#B4BED7, 0.52);
      }
      &.password {
        .el-form-item__content {
          position: relative;
          padding-right: val(50);
          .security-level {
            position: absolute;
            right: 0;
            bottom: 0;
            padding-bottom: val(10);
            padding-right: val(13);
            font-size: val(16);
          }
        }
      }
      &.mobile {
        .el-form-item__content {
          position: relative;
          padding-right: val(120);
          .send-message {
            width: val(106);
            cursor: pointer;
            position: absolute;
            right: 0;
            bottom: 0;
            padding: 0 0 val(10) val(13);
            font-size: val(16);
            color: #0077E8;
            box-sizing: border-box;
            &:before {
              content: "";
              position: absolute;
              left: 0;
              top: val(2);
              width: 1px;
              height: val(12);
              background: #B4BED7;
              opacity: 0.52;
            }
          }
        }
      }
    }
  }
</style>
